import React, { useId } from 'react';
import ReactModal from 'react-modal';
import { VideoData } from 'types/video-data';

// import components
import PopupCard from 'components/partials/parts/popup-card';
import VideoEmbed from 'components/partials/parts/video-embed';

type VideoModalProps = {
    videoData?: VideoData;
    isOpen?: boolean;
    closeModal: () => void;
};

// https://reactcommunity.org/react-modal/accessibility/#app-element
ReactModal.setAppElement('#___gatsby');

const VideoModal: React.FC<VideoModalProps> =({ videoData, isOpen, closeModal }) => {

    if (!videoData) return null;

    let videoId = videoData?.id || useId().replaceAll(':', '');

    let headline = videoData?.title || '';

    return (
        <ReactModal
            closeTimeoutMS={250}
            isOpen={isOpen ?? false}
            contentLabel={headline}
            className="popup-card"
            overlayClassName="popup-overlay bg-brand-teal"
        >
            <PopupCard
                headline={headline}
                onClickClose={closeModal}
            >
                <VideoEmbed {...videoData} />
            </PopupCard>
        </ReactModal>
    );
};

export default VideoModal;